import React, { InputHTMLAttributes } from "react";
import { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';

import './RadioCustom.scss';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  checked: boolean;
  containerClassName?: string;
  diabled?:boolean;
  error?: string;
  errorId?: string;
  id: string;
  invalid?: boolean;
  label: string;
  labelHeader?: boolean;
  labelClassName?: string;
  radioContainerClassName?: string;
}

const RadioCustom: React.FC<Props> = ({ 
  checked,
  containerClassName,
  disabled,
  error,
  errorId,
  id,
  invalid,
  label,
  labelHeader,
  labelClassName,
  radioContainerClassName,
  ...props
}) => {
  const inputRef = useRef(null);
  const [inputFocused, setInputFocused] = useState(false);

  useEffect(() => {
    setInputFocused(document.activeElement === inputRef.current);

  }, [document.activeElement, inputRef]);

  const containerClassNameClsx = clsx(['radio-container', containerClassName]);
  const labelClassNameClsx = clsx([
    'radio-custom__label',
    labelHeader && 'radio-custom__label--header',
    invalid && 'radio-custom--invalid',
    checked && 'radio-custom__label--checked',
    inputFocused && 'radio-custom__label--focused',
    disabled && 'radio-custom__label--disabled',
    labelClassName,
  ]);
  const radioClassName = clsx(['radio-custom__input', radioContainerClassName]);

  return (
    <div className={containerClassNameClsx}>
      <input
        aria-describedby={errorId || undefined}
        className={radioClassName}
        checked={checked}
        disabled={disabled}
        id={id}
        type="radio"
        ref={inputRef}
        {...props}
      />
      <label htmlFor={id} className={labelClassNameClsx}>
        {label}
        {checked
          ? <RadioButtonCheckedIcon className={`radio-custom__icon radio-custom__icon--checked${disabled ? ' radio-custom__icon--disabled' : ''}`} />
          : <RadioButtonUncheckedIcon className={`radio-custom__icon${disabled ? ' radio-custom__icon--disabled' : ''}`} />
        }
      </label>
      {errorId && <p id={errorId} className="radio-custom__error" role="alert">{error}</p>}
    </div>
  )
};

export default RadioCustom;